import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a5a7da"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "onClick"]
const _hoisted_2 = {
  key: 1,
  style: {"margin-top":"5px","font-size":"13px","display":"flex","align-items":"center","justify-content":"center","gap":"5px"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "description-text" }
const _hoisted_6 = { class: "description-text" }
const _hoisted_7 = { class: "description-text" }
const _hoisted_8 = { class: "description-text" }
const _hoisted_9 = {
  key: 2,
  class: "description-text",
  style: {"padding":"10px"}
}
const _hoisted_10 = { class: "graphdurationweek" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Transiciones de una tipología a otra"))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Transiciones desde una tipología a otra"))
const _hoisted_13 = { style: {"font-size":"16px"} }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "color-picker-row" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Guardar ")

import { onUnmounted, nextTick, onMounted, ref, watch } from "vue";
import { ReportFilter } from "@/types/report.type";
import { Parameter } from "@/types/parameter.type";
import GraphDonutChartComponent from "../graphs/graphDonutChart.component.vue";
import ElMessage from "element-plus/lib/components/message";
import { useI18n } from "vue-i18n";
import {
  calculateParameterRange,
  calculateTmoaRange,
  postParameterRange,
  getParameterRange,
  calculateTmoaPercentagesRanges,
} from "@/service/parameterRange.service";
import {
  TableParameterRange,
  TableRange,
  ParameterRange,
  TablePercentageRow,
  TablePercentage,
} from "@/types/parameterRange.type";
import { ValidationFilter_2 } from "@/types/estimation.type";
import { Filter } from "@/types/filter.type";
import { getTmoa, updateTmoaUser, updateTmoa } from "@/service/tmoa.service";
import { sortByType } from "@/utils/tmoa.util";
import type { RowClassNameGetter } from "element-plus";
import { Tmoa } from "@/types/tmoa.type";
import { Estimation } from "@/types/estimation.type";
import { Color } from "@amcharts/amcharts5/.internal/core/util/Color";
import { Refresh } from "@element-plus/icons-vue";
import * as am5 from "@amcharts/amcharts5";
import { formatNumber, parseNumber } from "@/utils/estimation.util";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { exportToPdf } from "@/utils/pdf.util";
import DurationAnalysisTable from "@/components/reports/reportsDurationAnalysis.component.vue";
import { getPaginatedEstimations } from "@/service/estimation.service";
import { percentage } from "@/utils/math.util.ts";
import GraphTimeDistributionComponent from "../graphs/graphTimeDistribution.component";
import { getParameterRanges } from "@/service/estimation.service";
import ReportTransactionTable from "../reports/reportTransactionTable.component";
import { getParameter } from "@/service/parameter.service";
import { getImageTmoa } from "@/service/image.service";
import { getSamPointOnlyParameters } from "@/service/samplingpoint.service";


export default /*#__PURE__*/_defineComponent({
  props: {
    reportFilter: null,
    parameter: null,
    point: null,
    date: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  reportFilter: ReportFilter;
  parameter: Parameter | undefined;
  point: string | undefined;
  date: string | undefined;
}


const tableParameterRange = ref<TableParameterRange[]>([]);
const tableTemporal = ref<TableRange[]>([]);
const tablePercentageRanges = ref<TablePercentageRow[]>([]);
const tableTmoa = ref<any[]>();
const tableTmoaCopy = ref<any[]>();
const tmoaImgs = ref<any[]>();

let graphProbability = ref<
  Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>
>([]);

const donutDuration = ref<
  Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>
>([]);

const donutDurationWeekend = ref<
  Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>
>([]);
const graphLoaded = ref<boolean>(false); // Control para cargar el componente
const openEditModal = ref<boolean>(false);
const disabledBtnSave = ref<boolean>(false);
let editedTmoa = ref<Tmoa>();

const isExporting = ref<boolean>(false);

const isWideScreen = ref<boolean>(window.innerWidth > 1490);

const { t } = useI18n();

const tableNewParameterRanges = ref<any[]>([]);

const showImageDialog = ref(false);
const showImageDataDialog = ref(false);
const selectedImage = ref("");

const srcTmoa = ref<Record<string, string>>({});
const itemData = ref<any>();

const samplingPointParams = ref<any[]>([]);

const hasTmoaInSamplingPoint = ref(false);

const data_estimations = ref<Estimation[]>([]);
const data_estimations_reverse = ref<Estimation[]>([]);

const isLoading = ref(false);
let loadingTimer: number | null = null;

const isFetching = ref(false);

const safeGetInformation = async () => {
  if (isFetching.value) return;
  isFetching.value = true;
  try {
    await getInformation();
  } finally {
    isFetching.value = false;
  }
};

onMounted(async () => {
  openEditModal.value = false;
  disabledBtnSave.value = false;

  await getInformation();

  // const tmoaParamId = getTmoaIdFromSamplingPoint(samplingPointParams.value);
  // const parameterIdForFilter =
  //   props.parameter?.code === "TMOA"
  //     ? props.parameter.id
  //     : hasTmoaInSamplingPoint.value
  //     ? tmoaParamId
  //     : props.parameter?.id;

  // const validationFilter = {
  //   samplingPointId: props.reportFilter.samplingPointIds,
  //   parameterId: [parameterIdForFilter],
  //   date: [props.reportFilter.date[0], props.reportFilter.date[1]],
  // } as ValidationFilter_2;

  // data_estimations.value = await getPaginatedEstimations(validationFilter);

  await nextTick();
  window.addEventListener("resize", updateScreenSize);
});

function showLoaderDelayed(delayMs = 200) {
  if (loadingTimer != null) return;
  loadingTimer = window.setTimeout(() => {
    isLoading.value = true;
    loadingTimer = null;
  }, delayMs);
}

function hideLoader() {
  if (loadingTimer != null) {
    clearTimeout(loadingTimer);
    loadingTimer = null;
  }
  isLoading.value = false;
}
const loadTmoaImages = async (items: any[]) => {
  const images: Record<string, string> = {};

  await Promise.all(
    items.map(async (item) => {
      if (item.file) {
        images[item.file] = await getImageTmoa(item.file);
      }
    })
  );

  srcTmoa.value = images; // ← UNA sola mutación
};
const openImage = (file: string, item: any) => {
  itemData.value = item;
  selectedImage.value = file;
  showImageDialog.value = true;
};

const openData = (file: string, item: any) => {
  itemData.value = item;
  selectedImage.value = file;
  showImageDataDialog.value = true;
};

const saveTmoaData = async () => {
  await updateTmoa(
    itemData.value.id,
    itemData.value.name,
    itemData.value.value,
    itemData.value.file,
    itemData.value.color
  );
  showImageDataDialog.value = false;
  await getInformation();
};

const normalizeString = (str: string) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const spanMethod = ({ column, rowIndex }) => {
  if (!column) return;
  if (column.property === "code") {
    if (tableNewParameterRanges.value.length === 0) return { rowspan: 1, colspan: 1 };
    if (rowIndex === 0) {
      return { rowspan: tableNewParameterRanges.value.length, colspan: 1 };
    } else {
      return { rowspan: 0, colspan: 0 };
    }
  }
  return;
};

/**
 *
 * @param data
 */
const getPercentageWeek = (data: Estimation[]) => {
  donutDuration.value = [] as Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>;
  donutDurationWeekend.value = [] as Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>;
  const { dataWeek, dataWeekend } = getDayDistribution(data);
  const percentageWeek = percentage(dataWeek);
  const percentageWeekend = percentage(dataWeekend);

  tableTmoaCopy.value.forEach((tmoa) => {
    let valueGraph = percentageWeek[String(tmoa.value)];
    if (valueGraph) {
      valueGraph = Number(valueGraph.replace("%", ""));
    } else {
      valueGraph = 0;
    }

    donutDuration.value.push({
      name: tmoa.name,
      value: valueGraph,
      tmoa: tmoa.name,
      strokeSettings: {
        fill: am5.color(Number(tmoa.color.replace("#", "0x"))),
        stroke: am5.color(Number(tmoa.color.replace("#", "0x"))),
      },
    });

    let valueGraphWeekend = percentageWeekend[String(tmoa.value)];
    if (valueGraphWeekend) {
      valueGraphWeekend = Number(valueGraphWeekend.replace("%", ""));
    } else {
      valueGraphWeekend = 0;
    }

    donutDurationWeekend.value.push({
      name: tmoa.name,
      value: valueGraphWeekend,
      tmoa: tmoa.name,
      strokeSettings: {
        fill: am5.color(Number(tmoa.color.replace("#", "0x"))),
        stroke: am5.color(Number(tmoa.color.replace("#", "0x"))),
      },
    });
  });
};

const getDayDistribution = (data: Estimation[]) => {
  const dataWeek: Array<number> = [];
  const dataWeekend: Array<number> = [];

  data.forEach((item) => {
    const date = new Date(item.dateTime);
    const day = date.getDay();

    //- lunes -viernes
    if (day >= 1 && day <= 5) {
      dataWeek.push(item.value);
    } else {
      dataWeekend.push(item.value);
    }
  });

  return { dataWeek, dataWeekend };
};

/**
 *
 * @param pdf
 * @param imgData
 */

const addWatermark = (pdf: jsPDF, imgData: string) => {
  const pageCount = pdf.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);

    // Puedes ajustar tamaño y posición aquí
    const width = 150;
    const height = 45;
    const x = (pdf.internal.pageSize.getWidth() - width) / 2;
    const y = (pdf.internal.pageSize.getHeight() - height) / 2;

    pdf.addImage(imgData, "PNG", x, y, width, height, "", "NONE", 0.1); // 0.1 = opacidad
  }
};

const getBase64Image = (url: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (ctx?.globalAlpha) {
        ctx.globalAlpha = 0.05;
      }
      ctx?.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (err) => reject(err);
  });
};

const btnExportToPdf = async () => {
  // Ocultar columnas antes de empezar
  isExporting.value = true;

  const tmoaContainer = document.querySelector(".tmoa-images-container");
  tmoaContainer?.classList.add("pdf-mode");

  await nextTick();

  setTimeout(async () => {
    const title = `Informe de ${props.parameter?.name} en ${props.point}`;
    const subtitle = `${props.date}`;

    const dateTime1 = props.date?.split(" - ")[0];
    const date1 = dateTime1 ? dateTime1.split("/") : "";
    const time1 = date1[2].split(":");
    const dateString1 = `${date1[2].split(" ")[0]}${date1[1]}${date1[0]}${time1[0].split(" ")[1]}${
      time1[1]
    }`;
    const dateTime2 = props.date?.split(" - ")[1];
    const date2 = dateTime2 ? dateTime2.split("/") : "";
    const time2 = date2[2].split(":");
    const dateString2 = `${date2[2].split(" ")[0]}${date2[1]}${date2[0]}${time2[0].split(" ")[1]}${
      time1[1]
    }`;

    const namePDF = `${props.point?.replace(/ /g, "_")}_${
      props.parameter?.code
    }_${dateString1}_${dateString2}`;
    // Mostrar de nuevo las columnas ocultas después de capturar
    // await exportToPdf(title, subtitle, namePDF, ["a", "b"]);
    const arrayElementPdf = ["a", "b", "c", "d", "e"];
    await exportToPdf(title, subtitle, namePDF, arrayElementPdf);

    tmoaContainer?.classList.remove("pdf-mode");
    isExporting.value = false;
  }, 200);
};

const getTmoaNameByValue = (row: any, column: any, cellValue: any): string => {
  const value = Number(cellValue);
  const found = tableTmoa.value?.find((item) => item.value === value);

  if (!found) return "";

  return found.name?.trim() ? found.name : found.type || "";
};

const getInformation = async () => {
  try {
    graphLoaded.value = false;

    tableTemporal.value = [];
    tablePercentageRanges.value = [];
    tableNewParameterRanges.value = [];
    tableTmoa.value = [];

    showLoaderDelayed(200);

    samplingPointParams.value = await getSamPointOnlyParameters(
      props.reportFilter.samplingPointIds[0]
    );
    hasTmoaInSamplingPoint.value = samplingPointParams.value?.some((p) => p.code === "TMOA");

    if (!props.parameter) {
      hideLoader();
      return;
    }

    const isSelectedParamTmoa = props.parameter.code === "TMOA";
    const tmoaParamId = getTmoaIdFromSamplingPoint(samplingPointParams.value);
    const parameterIdForFilter = isSelectedParamTmoa
      ? props.parameter.id
      : hasTmoaInSamplingPoint.value
      ? tmoaParamId
      : props.parameter.id;

    const validationFilter: ValidationFilter_2 = {
      samplingPointId: [props.reportFilter.samplingPointIds[0]],
      parameterId: [parameterIdForFilter],
      date: [props.reportFilter.date[0], props.reportFilter.date[1]],
    };

    // TMOA
    tableTmoa.value = sortByType([...(await getTmoaBySamplingPoint())]);
    tmoaImgs.value = [...tableTmoa.value].filter((tmoa) => tmoa.file);
    const estimationsTmoa = [...tableTmoa.value];
    estimationsTmoa.pop();
    tableTmoaCopy.value = estimationsTmoa;

    const estimations = await getEstimationsTmoa();

    data_estimations_reverse.value = [...estimations].sort(
      (a, b) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
    );

    data_estimations.value = [...estimations].sort(
      (a, b) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
    );

    // cálculo de gráficas
    getPercentageWeek(data_estimations.value);

    if (isSelectedParamTmoa || hasTmoaInSamplingPoint.value) {
      loadTmoaImages(tableTmoa.value);

      const info = await calculateTmoaRange(validationFilter);
      const info2 = await calculateTmoaPercentagesRanges(validationFilter);

      showInformation(info);
      showInformation2(info2);

      tableNewParameterRanges.value = (
        await getParameterRanges(
          props.reportFilter.samplingPointIds[0],
          props.parameter.id,
          props.reportFilter.date[0],
          props.reportFilter.date[1]
        )
      ).filter((item) => normalizeString(item.name || "") !== "anomalia");

      hideLoader();
      return;
    }

    tableNewParameterRanges.value = (
      await getParameterRanges(
        props.reportFilter.samplingPointIds[0],
        props.parameter.id,
        props.reportFilter.date[0],
        props.reportFilter.date[1]
      )
    ).filter((item) => normalizeString(item.name || "") !== "anomalia");

    await getInformationRange(props.parameter, validationFilter);

    hideLoader();
  } catch (err) {
    console.error("[getInformation] error", err);
    hideLoader();
  }
};

/**
 * Obtener las estimaciones del parámetro Tipología de Agua (TMOA)
 */
const getEstimationsTmoa = async () => {
  const filter: Filter = {
    fields: {
      "parameter.code": {
        operator: "equal",
        value: "TMOA",
      },
    },
  };
  const parameterTmoa = (await getParameter(undefined, undefined, filter))?.data;
  //- Solo matrices de agua
  const validationFilterTmoa = {
    samplingPointId: props.reportFilter.samplingPointIds,
    parameterId: [parameterTmoa[0].id],
    date: [props.reportFilter.date[0], props.reportFilter.date[1]],
  } as ValidationFilter_2;
  const estimations = (await getPaginatedEstimations(validationFilterTmoa)).filter(
    (estimation) => estimation.value != tableTmoaCopy.value.length + 1
  );
  console.log("Estimations ", estimations);
  return estimations;
};

const getTmoaIdFromSamplingPoint = (params: any[]) => {
  return params.find((p) => p.code === "TMOA")?.id;
};

const getInformationRange = async (parameter: Parameter, validationFilter: ValidationFilter_2) => {
  const isSelectedParamTmoa = props.parameter.code === "TMOA";
  const tmoaParamId = getTmoaIdFromSamplingPoint(samplingPointParams.value);
  const parameterIdForFilter = isSelectedParamTmoa
    ? props.parameter.id
    : hasTmoaInSamplingPoint.value
    ? tmoaParamId
    : props.parameter.id;
  const parameterRanges = await getParameterRange(
    props.reportFilter.samplingPointIds[0],
    parameterIdForFilter
  );
  if (parameterRanges.length > 0) {
    tableParameterRange.value = [];
    //- Parámetros
    [1, 2, 3, 4].forEach((range) => {
      const existRange = parameterRanges.find((_) => _?.nameRange === `Rango ${range}`);
      if (existRange) {
        tableParameterRange.value.push({
          id: existRange.id,
          nameRange: `${t("label.range")} ${range}`,
          beginningRange: formatNumber(existRange.beginningRange),
          endRange: formatNumber(existRange.endRange),
          samplingPoint: existRange.samplingPoint,
          parameter: existRange.parameter,
        });
      } else {
        tableParameterRange.value.push({
          nameRange: `${t("label.range")} ${range}`,
          beginningRange: undefined,
          endRange: undefined,
        });
      }
    });

    tableTemporal.value = [] as TableRange[];
    const information = await calculateParameterRange(validationFilter);
    if (information) {
      showInformation(information);
    }
  } else {
    //- Si no se han establecido parámetros

    await initialParameterRange();
    graphProbability.value = [] as Array<{ name: string; value: number; tmoa: string }>;
    tableTemporal.value = [] as TableRange[];
  }
};

const showInformation = (information: { tableRange: TableRange[]; graphProbability: number[] }) => {
  tableTemporal.value = [];
  graphProbability.value = [];

  const isTmoa = hasTmoaInSamplingPoint;

  information.tableRange?.forEach((element) => {
    element.nameRange = `${element.nameRange}`;
    element.min_duration = element.min_duration || "N/A";
    element.max_duration = element.max_duration || "N/A";
    element.average_duration = element.average_duration || "N/A";
    element.median = element.median || "N/A";
    element.total = element.total || "N/A";
    tableTemporal.value?.push(element);
  });

  information.graphProbability?.forEach((value, index) => {
    if (value !== undefined && value > 0) {
      let name: string | undefined = undefined;
      let tmoaLabel: string | undefined = undefined;
      let strokeSettings: { fill: Color; stroke: Color };

      if (isTmoa) {
        const tmoa = tableTmoa.value?.find((t) => t.value === index + 1);
        name = tmoa?.name?.trim() || `TMOA ${index + 1}`;
        tmoaLabel = name;
        strokeSettings = {
          fill: am5.color(Number(tmoa.color.replace("#", "0x"))),
          stroke: am5.color(Number(tmoa.color.replace("#", "0x"))),
        };
      } else {
        name = `Rango ${index + 1}`;
      }

      const entry: any = {
        name,
        value,
        strokeSettings,
      };

      if (isTmoa) {
        entry.tmoa = tmoaLabel;

        // Caso mostrar anomalías
        // if (index + 1 === tableTmoa.value?.length) {
        //   entry.strokeSettings = {
        //     fill: am5.color(0xf37878),
        //     stroke: am5.color(0xf37878),
        //   };
        // }
      }

      graphProbability.value.push(entry);
    }
  });

  // Mostrar gráfico si hay datos
  if (graphProbability.value.length > 0) {
    graphProbability.value = graphProbability.value.filter(
      (item) => normalizeString(item.name || "") !== "anomalia"
    );
    graphLoaded.value = true;
  }
};

const showInformation2 = (information: TablePercentageRow[]) => {
  tablePercentageRanges.value = information.map((item) => ({
    nameRange: item.nameRange,
    percentages: {
      total: item.percentages.total ?? 0,
      min5: item.percentages.min5 ?? 0,
      min10: item.percentages.min10 ?? 0,
      min15: item.percentages.min15 ?? 0,
      min30: item.percentages.min30 ?? 0,
      h1: item.percentages.h1 ?? 0,
      other: item.percentages.other ?? 0,
    },
  }));
};

const initialParameterRange = async () => {
  tableParameterRange.value = [] as TableParameterRange[];
  for (let index = 0; index < 4; index++) {
    tableParameterRange.value.push({
      id: undefined,
      nameRange: `${t("label.range")} ${index + 1}`,
      beginningRange: undefined,
      endRange: undefined,
      status: false,
    });
  }
};

const getTmoaBySamplingPoint = () => {
  const samplingPointId = props.reportFilter.samplingPointIds[0];
  const filter: Filter = {
    fields: {
      "tmoa.samplingPointId": { operator: "equal", value: samplingPointId },
    },
  };
  return getTmoa(filter);
};

const updateScreenSize = () => {
  console.count("resize listener");
  isWideScreen.value = window.innerWidth > 1445;
};

// - VUE EXPOSE
expose({
  btnExportToPdf,
});

watch(
  () => props.parameter,
  () => safeGetInformation(),
  { deep: false }
);

watch(
  () => props.reportFilter.date,
  () => safeGetInformation(),
  { deep: true }
);

onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
  srcTmoa.value = {};
  graphProbability.value = [];
  donutDuration.value = [];
  donutDurationWeekend.value = [];
});

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_scrollbar, { height: "70vh" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { id: "a" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: "sticky-tmoa"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  id: "header-range",
                  class: "header static full-width"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.knownTmoas")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  class: "tmoa-images-container",
                  style: {"display":"flex","flex-wrap":"nowrap","gap":"15px","overflow-x":"auto","padding-bottom":"10px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tmoaImgs.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        key: `tmoa-${item.id}`,
                        span: 6,
                        style: {"text-align":"center","flex":"0 0 auto","background-color":"rgb(245, 247, 250)","padding":"5px"}
                      }, {
                        default: _withCtx(() => [
                          (srcTmoa.value[item.file])
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: srcTmoa.value[item.file],
                                alt: item.name,
                                onClick: ($event: any) => (openImage(srcTmoa.value[item.file], item)),
                                style: {"width":"100%","max-height":"90px","object-fit":"contain","cursor":"pointer"}
                              }, null, 8, _hoisted_1))
                            : _createCommentVNode("", true),
                          (item.file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (item.color)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (openImage(srcTmoa.value[item.file], item)),
                                      style: _normalizeStyle({
                  backgroundColor: item.color,
                  width: '12px',
                  height: '12px',
                  display: 'inline-block',
                  borderRadius: '2px',
                  border: '1px solid #ccc',
                })
                                    }, null, 12, _hoisted_3))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(item.name || "TMOA " + item.value), 1),
                                _createVNode(_component_el_tooltip, { content: "Editar" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("em", {
                                      style: { cursor: 'pointer' },
                                      class: "el-icon el-icon-edit fas",
                                      onClick: ($event: any) => (openData(srcTmoa.value[item.file], item))
                                    }, null, 8, _hoisted_4)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.parameter?.code !== 'TMOA')
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  class: "block-section"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, {
                      class: "row-table static",
                      style: {"min-height":"160px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, {
                          id: "header-range",
                          class: "header full-width"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.parameterRanges")), 1)
                          ]),
                          _: 1
                        }),
                        (isLoading.value)
                          ? (_openBlock(), _createBlock(_component_el_skeleton, {
                              key: 0,
                              animated: "",
                              rows: 4,
                              class: "w-100",
                              style: {"width":"100%","padding":"10px 0"}
                            }))
                          : (tableNewParameterRanges.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_el_table, {
                                key: 1,
                                data: tableNewParameterRanges.value,
                                border: "",
                                class: "table-report tables",
                                "span-method": spanMethod
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "code",
                                    label: " ",
                                    "header-align": "center",
                                    align: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.parameter?.code), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Tipología",
                                    "header-align": "center",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("span", _hoisted_6, _toDisplayString(scope.row.name), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "Rango total",
                                    "header-align": "center",
                                    align: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        prop: "min",
                                        label: "Mínimo",
                                        align: "center"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.min ?? "-"), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "max",
                                        label: "Máximo",
                                        align: "center"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.max ?? "-"), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_9, "No hay datos"))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 2,
          id: "b",
          class: "analysisBlock"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 18,
              class: "responsive-row"
            }, {
              default: _withCtx(() => [
                _createVNode(DurationAnalysisTable, {
                  params: samplingPointParams.value,
                  table: tableTemporal.value,
                  tablePercentageRanges: tablePercentageRanges.value,
                  parameter: __props.parameter,
                  getTmoaNameByValue: getTmoaNameByValue,
                  "is-tmoa-data": hasTmoaInSamplingPoint.value
                }, null, 8, ["params", "table", "tablePercentageRanges", "parameter", "is-tmoa-data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "responsive-col"
            }, {
              default: _withCtx(() => [
                (graphLoaded.value && _unref(graphProbability))
                  ? (_openBlock(), _createBlock(GraphDonutChartComponent, {
                      key: 0,
                      ref: "graphDonut2",
                      idChart: "chartdiv",
                      probability: _unref(graphProbability)
                    }, null, 8, ["probability"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          id: "d",
          class: "block-tmoa",
          gutter: 2
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "header full-width" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("label.timeDistribution")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                (data_estimations.value.length > 0)
                  ? (_openBlock(), _createBlock(_unref(GraphTimeDistributionComponent), {
                      key: 0,
                      data: data_estimations.value,
                      point: __props.reportFilter.samplingPointIds[0],
                      tmoa: tableTmoaCopy.value
                    }, null, 8, ["data", "point", "tmoa"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  (data_estimations.value.length > 0 && donutDuration.value && donutDuration.value.length > 0)
                    ? (_openBlock(), _createBlock(GraphDonutChartComponent, {
                        key: 0,
                        ref: "graphChart",
                        probability: donutDuration.value,
                        idChart: 'chartdurationweek',
                        title: _unref(t)('label.tmoasFromMonToFri')
                      }, null, 8, ["probability", "title"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (
              data_estimations.value.length > 0 && donutDurationWeekend.value && donutDurationWeekend.value.length > 0
            )
                    ? (_openBlock(), _createBlock(GraphDonutChartComponent, {
                        key: 0,
                        ref: "graphDonut",
                        probability: donutDurationWeekend.value,
                        idChart: 'chartdurationweekend',
                        title: _unref(t)('label.tmoasFromSatToSun'),
                        id: "graphdurationweekend"
                      }, null, 8, ["probability", "title"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.parameter.code === 'TMOA')
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              id: "e",
              class: "block-tmoa"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  id: "header-range",
                  class: "header full-width"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.transactionTmoas")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  id: "header-range",
                  class: "sub-header full-width"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                (data_estimations_reverse.value.length > 0 && tableTmoaCopy.value.length > 0)
                  ? (_openBlock(), _createBlock(_unref(ReportTransactionTable), {
                      key: 0,
                      estimations: data_estimations_reverse.value,
                      tmoas: tableTmoaCopy.value,
                      reverse: true,
                      class: "table"
                    }, null, 8, ["estimations", "tmoas"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_row, {
                  id: "header-range",
                  class: "sub-header full-width"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                (data_estimations.value.length > 0 && tableTmoaCopy.value.length > 0)
                  ? (_openBlock(), _createBlock(_unref(ReportTransactionTable), {
                      key: 1,
                      estimations: data_estimations.value,
                      tmoas: tableTmoaCopy.value,
                      reverse: false,
                      class: "table"
                    }, null, 8, ["estimations", "tmoas"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: showImageDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showImageDialog).value = $event)),
      width: "40%",
      "show-close": true,
      center: ""
    }, {
      default: _withCtx(() => [
        (itemData.value.color)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: _normalizeStyle({
        backgroundColor: itemData.value.color,
        width: '15px',
        height: '15px',
        display: 'inline-block',
        borderRadius: '2px',
        border: '1px solid #ccc',
        marginRight: '5px',
      })
            }, null, 4))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_13, _toDisplayString(itemData.value.name || "TMOA " + itemData.value.value), 1),
        _createElementVNode("img", {
          src: selectedImage.value,
          alt: "",
          style: {"width":"100%","object-fit":"contain","margin-top":"10px"}
        }, null, 8, _hoisted_14)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showImageDataDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showImageDataDialog).value = $event)),
      width: "420px",
      "show-close": true,
      center: "",
      title: "Editar tipología"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showImageDataDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: disabledBtnSave.value,
          onClick: saveTmoaData
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        (itemData.value)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: itemData.value,
              "label-position": "top",
              class: "tmoa-form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "Nombre" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: itemData.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((itemData.value.name) = $event)),
                      placeholder: "Nombre"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Color" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_color_picker, {
                        modelValue: itemData.value.color,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemData.value.color) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", {
                        class: "color-preview",
                        style: _normalizeStyle({ backgroundColor: itemData.value.color })
                      }, null, 4)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})